import { render, staticRenderFns } from "./InboxMessageItem.vue?vue&type=template&id=7cf34c58&scoped=true&"
import script from "./InboxMessageItem.vue?vue&type=script&lang=js&"
export * from "./InboxMessageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf34c58",
  null
  
)

export default component.exports